<template>
	<div class="d-flex min-vh-100 align-items-center justify-content-center logout">
		<p>Logging out...</p>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { ROUTE_NAME } from '../enums/route';

export default {
	name: 'LogoutPage',
	data() {
		return {
			version: process.env.VUE_APP_VERSION,
		};
	},
	computed: {
		...mapState('auth', ['isLoggedIn']),
	},
	async created() {
		try {
			if (this.isLoggedIn) {
				await this.logout();
			}
		} catch (e) {
			// eslint-disable-next-line
			console.error('Logout error:', e);
		} finally {
			this.$router.replace({ name: ROUTE_NAME.LOGIN });
		}
	},
	mounted() {
		document.body.style.setProperty('--version', `"v${this.version}"`);
	},
	methods: {
		...mapActions('auth', ['logout']),
	},
};
</script>

<style scoped>
.logout {
	color: #777;

	&::after {
		content: var(--version);
		position: fixed;
		bottom: 20px;
		right: 20px;
		opacity: 0.3;
		font-size: 14px;
		color: #000;
		pointer-events: none;
		z-index: 9999;
		user-select: none;
		white-space: nowrap;
	}
}
</style>
